import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsStateModule } from './clients/clients.state.module';
import { StaffStateModule } from './staff/staff.state.module';
import { OrganizationStateModule } from './organization/organization.state.module';
import { CurrentUserStateModule } from './currentUser/current-user.state.module';
import { LocationsStateModule } from './locations/locations.state.module';
import { ProjectsStateModule } from './projects/projects.state.module';
import { TemplatesStateModule } from './templates/templates.state.module';

@NgModule({
  imports: [
    CommonModule,
    ClientsStateModule,
    StaffStateModule,
    OrganizationStateModule,
    CurrentUserStateModule,
    LocationsStateModule,
    ProjectsStateModule,
    TemplatesStateModule
  ],
  providers: [],
})
export class StateModule {}
